module.exports = __webpack_public_path__ + "img/grants.598a96c3.svg";